import type React from 'react';

import { ChevronSortIcon } from '@vlabs/icons';
import type { TOption } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { DropdownSelect } from '@vlabs/monokit/shared/ui/dropdown-select';

import { useCardsFilters } from '../filters/useCardsFilters';
import { useEffect } from 'react';

export type TOrderParameter = 'create_time_asc' | 'create_time_desc' | 'fio_asc' | 'fio_desc';

interface SortCardsDropdownProps {
  disabled?: boolean;
}

function SortCardsDropdown({
  disabled = false,
}: SortCardsDropdownProps): React.JSX.Element {
  const { t } = useTranslation();
  const { filters, updateFilters } = useCardsFilters();

  const sortOptions: TOption<TOrderParameter>[] = [
    { label: t('card-list-page:sort dropdown options.date_asc'), value: 'create_time_asc' },
    { label: t('card-list-page:sort dropdown options.date_desc'), value: 'create_time_desc' },
    { label: t('card-list-page:sort dropdown options.fio_asc'), value: 'fio_asc' },
    { label: t('card-list-page:sort dropdown options.fio_desc'), value: 'fio_desc' },
  ];

  let filterValue: TOrderParameter = 'create_time_asc';
  if (filters.sort && filters.order) {
    if (filters.sort === 'create_time' && filters.order === 'asc') filterValue = 'create_time_asc';
    if (filters.sort === 'create_time' && filters.order === 'desc') filterValue = 'create_time_desc';
    if (filters.sort === 'user_data.fio' && filters.order === 'asc') filterValue = 'fio_asc';
    if (filters.sort === 'user_data.fio' && filters.order === 'desc') filterValue = 'fio_desc';
  }
  const selectedLabel = (sortOptions.find((o) => o.value === filterValue) as TOption<TOrderParameter>).label
    ?? t('card-list-page:sort dropdown options.date_asc');

  return (
    <DropdownSelect<TOrderParameter>
      disabled={disabled}
      icon={<ChevronSortIcon />}
      label={selectedLabel}
      onSelect={(value) => {
        switch (value) {
          case 'create_time_asc': {
            updateFilters({
              sort: 'create_time',
              order: 'asc',
            });
            break;
          }
          case 'create_time_desc': {
            updateFilters({
              sort: 'create_time',
              order: 'desc',
            });
            break;
          }
          case 'fio_asc': {
            updateFilters({
              sort: 'user_data.fio',
              order: 'asc',
            });
            break;
          }
          case 'fio_desc': {
            updateFilters({
              sort: 'user_data.fio',
              order: 'desc',
            });
            break;
          }
          default:
            throw new Error('undefined sort card value');
        }
      }}
      options={sortOptions}
      value={filterValue}
    />
  );
}

export { SortCardsDropdown };
